import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { generateImageSources } from "../../utils/utils";
import { getAudioPagePath } from "../../../data/collection";
import Icon from "../icon";

const ArticleBundleItem = ({ collection, cardWithImageZoom = true, className = "", config = {} }) => {
  const headline = get(collection, ["name"], "");
  const imageCaption = get(collection, ["metadata", "cover-image", "caption"]) || headline;
  const slug = get(collection, ["slug"], "");
  const coverImageS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], "");
  const authorName = get(collection.items[0], ["story", "author-name"], "Unknown");

  if (!(headline && slug)) {
    return null;
  }

  return (
    <Link
      aria-label="Magazine"
      className={`${styles["read-more-link"]} ${className}`}
      href={`${getAudioPagePath(slug, config)}?pfrom=spl-series-recommendations`}
      externalLink={`${getAudioPagePath(slug, config)}?pfrom=spl-series-recommendations`}
    >
      <ResponsiveImageWithFallback
        className={styles["image-wrapper"]}
        slug={coverImageS3Key}
        metadata={coverImageMetaData}
        alt={imageCaption}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [27, 8], screenWidthCoverage: 0.6 },
          { aspectRatio: [27, 8], screenWidthCoverage: 0.3 }
        )}
      />
      <div className={styles["content-sec"]}>
        <h2>{headline}</h2>
        <div className={styles["bottom-sec"]}>
          <div className={styles["authour"]}>
            <Icon type="author" />
            {authorName}
          </div>
          <div className={styles["audio-play"]}>
            <Icon type="play" />
          </div>
        </div>
      </div>
    </Link>
  );
};

ArticleBundleItem.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  collection: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "cover-image-metadata": PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
      }),
      "cover-image-s3-key": PropTypes.string,
      caption: PropTypes.string
    })
  }),
  config: PropTypes.shape()
};

export default ArticleBundleItem;
